import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from './AuthContext';
import { canAccessPage, getStoredRole, ROLE_ADMIN } from './components/Sidebar';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    // Optionally, display a loading spinner or placeholder
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && getStoredRole() !== ROLE_ADMIN) {
    return <Navigate to="/dashboard" />;
  }

  if (!adminOnly && !canAccessPage(location.pathname)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;